<template>
  <v-content class="support-activity page">
    <can I="list" a="HourlyAnalytic">
      <v-container grid-list-md>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Support Activity', to: '/activity' },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-tooltip left>
            <v-btn small flat fab :href="$route.fullPath" slot="activator">
              <v-icon>mdi-link-variant</v-icon>
            </v-btn>
            <span>{{ $route.fullPath }}</span>
          </v-tooltip>
        </v-toolbar>

        <v-card toolbar>
          <v-toolbar flat color="transparent">
            <v-card-title>
              <div class="headline">Support Activity Overview</div>
            </v-card-title>
            <v-spacer />
            <v-btn color="primary" @click="reload" :disabled="loading" :loading="loading">
              Reload
            </v-btn>
          </v-toolbar>

          <v-divider v-if="response" />
          <v-card-title v-if="response">
            <div class="title">Raw Analytics</div>
            <v-spacer />
            <v-icon @click="showRaw = !showRaw">mdi-developer-board</v-icon>
          </v-card-title>
          <v-slide-y-transition>
            <v-card-text v-show="showRaw">
              <pre v-if="response" v-html="response"></pre>
            </v-card-text>
          </v-slide-y-transition>
        </v-card>

        <v-layout row wrap>
          <v-flex xs12 v-if="hourlies">
            <v-card
              ><v-card-text>
                <apex
                  type="line"
                  width="100%"
                  height="400px"
                  :options="{
                    title: { text: 'Recent Activity', style: { fontSize: '24px' } },
                    labels: hourly_labels,
                    theme: { mode: 'dark' },
                    chart: {
                      background: '#424242',
                      fontFamily: 'Roboto, sans-serif',
                      zoom: { enabled: false },
                    },
                    xaxis: { type: 'datetime' },
                    yaxis: { min: 0 },
                    dataLabels: { enabled: false },
                    colors: ['#00AA33', '#FF8900', '#FF3300'],
                    stroke: { show: true, width: 2 },
                  }"
                  :series="hourlies"
                /> </v-card-text
            ></v-card>
          </v-flex>

          <v-flex xs12 v-if="activity">
            <v-card>
              <v-data-table
                :headers="headers"
                :loading="loading"
                :items="activity"
                class="elevation-2"
                hide-actions
              >
                <template slot="items" slot-scope="{ item }">
                  <td>
                    <strong>
                      {{ new Date(item.start) | date('HH:mm') }} -
                      {{ new Date(item.end) | date('HH:mm') }}
                    </strong>
                    on {{ new Date(item.start) | date('do MMM yyyy') }}
                  </td>
                  <td>
                    <router-link :to="`/administrators/${item.administrator.id}`">
                      {{ item.administrator.fullName }}
                    </router-link>
                  </td>
                  <td>{{ item.verifiedCount }}</td>
                  <td>{{ item.flagCount }}</td>
                  <td>{{ item.qualificationCount }}</td>
                  <td>{{ item.endpointAccessCount }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Vue Component
export default {
  name: 'SupportActivity',
  created() {
    this.reload()
  },
  data() {
    return {
      loading: false,
      activity: [],
      hourlies: [],
      hourly_labels: [],
      response: null,
      error: null,
      showRaw: false,
      headers: [
        { text: 'Shift', value: 'start' },
        { text: 'Support Member', value: 'administrator.fullName' },
        { text: 'Verified', value: 'verifiedCount' },
        { text: 'Flagged', value: 'flagCount' },
        { text: 'Qualifications Added', value: 'qualificationCount' },
        { text: 'Activity', value: 'endpointAccessCount' },
      ],
    }
  },
  methods: {
    reload() {
      this.loading = true
      const hourly = Vue.$http
        .get('admin/tools/support_activity/hourly_analytics')
        .then(({ data }) => {
          // Empty data sets
          var verifications = { name: 'Verifications', data: [] }
          var qualifications = { name: 'Qualifications', data: [] }
          var flags = { name: 'Flags', data: [] }
          data.forEach(item => {
            this.hourly_labels.push(item.start)
            verifications.data.push(item.verified_count)
            qualifications.data.push(item.qualification_count)
            flags.data.push(item.flag_count)
          })

          this.hourlies = [verifications, qualifications, flags]
        })
      const activity = Vue.$http
        .get('admin/tools/support_activity/admin_analytics')
        .then(({ data }) => {
          this.activity = data
        })
      Promise.all([hourly]).then(() => (this.loading = false))
    },
  },
}
</script>
